
export const fileReader = (file: File) => {
    return new Promise<string> ((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            if(event.target && event.target.result) {
                resolve(event.target.result.toString());
            } else {
                reject(new Error("failed to read file"));
            }
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsText(file);
    })}